import { render, staticRenderFns } from "./penerimaankas.vue?vue&type=template&id=145a1478&scoped=true"
import script from "./penerimaankas.vue?vue&type=script&lang=js"
export * from "./penerimaankas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145a1478",
  null
  
)

export default component.exports